import { defHttp } from '/@/utils/http/axios';

enum Api {
    exportConfigApi = '/sys/commonExport/sysExport/queryByExportCode',
    commonExportApi = '/spp/common/export',
}

export const getCustomExportOptions = (params) => {
    return defHttp.get({ url: Api.exportConfigApi, params },);
};

export const commonExportFetch = (params) => {
    return defHttp.post({url:Api.commonExportApi, params},{successMessageMode: 'none'})
 }
